// 招待メールのリンクにある、招待IDとトークンを、ブラウザに一時保存する。
// リンクを開いたあと、ログインやサインアップの画面を挟んでも、承認の時点まで残すため。
// sessionStorage は、タブを閉じると消える。トークンは、URL に残さない。
const STORAGE_KEY = 'swBusinessInvitationLink'

// 現在の URL に、招待のリンクの情報があれば、保存して、URL から消す
export const captureInvitationLink = () => {
  try {
    const params = new URLSearchParams(window.location.search)
    const invitationId = params.get('invitationId')
    const invitationToken = params.get('invitationToken')
    if (!invitationId || !invitationToken) {
      return
    }
    sessionStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ invitationId, invitationToken })
    )
    params.delete('invitationId')
    params.delete('invitationToken')
    const search = params.toString()
    window.history.replaceState(
      null,
      '',
      window.location.pathname +
        (search ? `?${search}` : '') +
        window.location.hash
    )
  } catch (e) {
    // sessionStorage が使えない場合は、何もしない(リンクから開き直してもらう)
  }
}

// 指定した招待のトークンを返す。保存されているのが別の招待のものなら null
export const getInvitationToken = (invitationId) => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY))
    return saved && saved.invitationId === invitationId
      ? saved.invitationToken
      : null
  } catch (e) {
    return null
  }
}

export const clearInvitationLink = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch (e) {
    // 何もしない
  }
}

// 承認の失敗理由(サーバーのメッセージ)を、ユーザー向けの文言にする
export const invitationErrorText = (error) => {
  // サーバーの応答は、理由の文字列そのもの(例: "invitation expired")か、{ message } の形
  const data = error && error.response && error.response.data
  const raw = typeof data === 'string' ? data : data && data.message
  const message = Array.isArray(raw) ? raw.join(' ') : raw
  switch (message) {
    case 'invitation expired':
      return '招待の有効期限が切れています。管理者に、招待の再送を依頼してください。'
    case 'invitation locked':
      return 'この招待は、ロックされています。管理者に、招待の再送を依頼してください。'
    case 'invalid invitation token':
    case 'invitation token required':
      return '招待のメールに記載されたリンクから、もう一度開いてください。'
    default:
      return '招待の承認に失敗しました'
  }
}
